import { render, staticRenderFns } from "./TopVideoSw.vue?vue&type=template&id=f4aa5952&"
import script from "./TopVideoSw.vue?vue&type=script&lang=js&"
export * from "./TopVideoSw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports